<template>
<div class="animated fadeIn" v-if="floor">
  <b-card>
    <b-button-toolbar class="pull-right">
      <b-btn variant="primary" @click="showAddRoom">Add Room</b-btn>
    </b-button-toolbar>
  </b-card>

  <b-card :title="'Building: '+ floor.building.name+' - Floor: '+floor.floor_number">
    <v-client-table :data="rooms" :columns="columns" :options="options" :theme="theme" id="dataTable" ref="dataTable">
      <template slot="actions" slot-scope="data">
        <b-button class="mr-1" size="sm" variant="primary" @click="showEditModal(data.row)"><i class="fa fa-pencil"></i></b-button>
        <b-button class="mr-1" size="sm" variant="primary" @click="showSetAttributeModal(data.row)">Set Attributes</b-button>
      </template>
      <span slot="has_toilet" slot-scope="data">{{data.row.has_toilet ? data.row.toilet_type : 'No'}}</span>
      <span slot="has_ac" slot-scope="data">{{data.row.has_ac ? 'Yes' : 'No'}}</span>
      <template slot="attributes" slot-scope="data">
        <ul>
          <li v-for="atrribute in data.row.attributes">
            {{ atrribute.name }}: {{ atrribute.value }}
          </li>
        </ul>
      </template>
    </v-client-table>
  </b-card>

  <div>
    <b-modal ref="modalAddRoom" title="Add Room" hide-footer @hide="hideAddRoom" no-enforce-focus>
      <room-form-add v-if="canShowAddRoom" @success="addRoomSuccess" @cancel="cancelAddRoom" />
    </b-modal>
    <b-modal ref="modalEditRoom" title="Edit Room" hide-footer @hide="hideEditRoom" no-enforce-focus>
      <room-form-edit v-if="selectedRoom" :room="selectedRoom" @success="editRoomSuccess" @cancel="hideEditRoom" />
    </b-modal>
    <b-modal ref="modalSetAttributes" title="Set Attributes" hide-footer @hide="hideSetAttributes" no-enforce-focus>
      <set-attributes v-if="selectedSetAttributes" :object="selectedSetAttributes" type="ROOM" @success="setAttributeSuccess" @cancel="hideSetAttributes" />
    </b-modal>
  </div>
</div>
</template>

<script>
import {
  mapState
} from 'vuex'
import Vue from 'vue'
import RoomFormAdd from './RoomFormAdd'
import RoomFormEdit from './RoomFormEdit'
import SetAttributes from './SetAttributes'

export default {
  name: 'FloorList',
  components: {
    RoomFormAdd,
    RoomFormEdit,
    SetAttributes
  },
  computed: mapState({
    rooms: state => state.rooms.all,
  }),
  data: function() {
    return {
      floor: null,
      columns: [
        'room_number',
        'price',
        'number_of_beds',
        'max_occupiers',
        'has_toilet',
        'has_ac',
        'attributes',
        'actions'
      ],
      options: {
        headings: {
          room_number: 'Room Number',
          price: 'Bhent',
          number_of_beds: "Beds",
          max_occupiers: "Max Occupiers",
          has_toilet: "Toilet",
          has_ac: "AC",
          attributes: 'Atrributes',
          actions: 'Actions'
        },
        sortable: [],
        filterable: [],
        sortIcon: {
          base: 'fa',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
          is: 'fa-sort'
        },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'scroll'
        },
        perPage: 25,
      },
      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
      canShowAddRoom: false,
      selectedRoom: null,
      selectedSetAttributes: null
    }
  },
  methods: {
    showAddRoom() {
      this.canShowAddRoom = true
      this.$refs.modalAddRoom.show()
    },
    cancelAddRoom() {
      this.$refs.modalAddRoom.hide()
    },
    addRoomSuccess() {
      this.$refs.modalAddRoom.hide()
      this.$store.dispatch('rooms/getRooms', {
        building_id: this.$route.params.building_id,
        floor_id: this.$route.params.floor_id
      })
    },
    hideAddRoom() {
      this.canShowAddRoom = false
    },
    showEditModal(room) {
      this.selectedRoom = room
      this.$refs.modalEditRoom.show()
    },
    editRoomSuccess() {
      this.hideEditRoom()
      this.refresh()
    },
    hideEditRoom() {
      this.selectedRoom = null
      this.$refs.modalEditRoom.hide()
    },
    showSetAttributeModal(room) {
      this.selectedSetAttributes = room
      this.$refs.modalSetAttributes.show()
    },
    setAttributeSuccess() {
      this.hideSetAttributes()
      this.refresh()
    },
    hideSetAttributes() {
      this.selectedSetAttributes = null
      this.$refs.modalSetAttributes.hide()
    },
    refresh() {
      this.$store.dispatch('rooms/getRooms', {
        building_id: this.$route.params.building_id,
        floor_id: this.$route.params.floor_id
      })
    }
  },
  created() {
    this.refresh()
    this.$store.dispatch('floors/getFloor', {
        building_id: this.$route.params.building_id,
        floor_id: this.$route.params.floor_id
      })
      .then((response) => {
        this.floor = response.data.data
      })
    this.$store.dispatch('attributes/getAttributes')
  }
}
</script>
